!function(S) {
    S.fn.amxScanMngr = function(n, t) {
        function a() {
            S("#dvamxscan").html(m),
            S("#dvamxscan").show(),
            S(".scan-close").click(function() {
                S("#dvamxscan").hide(),
                S("#dvamxscan").html("")
            }),
            S.get(c + "templates/scan/config.html?v=" + u, function(n) {
                var c = S("<div/>").html(n).contents();
                S.each(l, function(n, t) {
                    var e, a = "<select id='ddScanners_" + n + "' onchange='onScannerChange(" + t.id + ",this)'>";
                    S.each(i, function(n) {
                        e = this == t.scannerName ? 'selected="selected"' : "",
                        a = a + "<option " + e + ">" + this + "</option>"
                    }),
                    a += "</select>",
                    c.find("#tblClientDocs").append("<tr><td >" + t.name + "</td><td>" + a + "</td></tr>")
                }),
                S(".scan-modal-body").append(c.html()),
                S("#btnSave_Scan_Config").click(function() {
                    S.each(l, function(n, t) {
                        t.scannerName = S("#ddScanners_" + n + " option:selected").text()
                    }),
                    localStorage.setItem("scan_" + s.name, JSON.stringify(l)),
                    S("#dvamxscan").hide(),
                    S("#dvamxscan").html(""),
                    d = !0
                }),
                S("#btnClose_Scan_Config").click(function() {
                    S("#dvamxscan").hide(),
                    S("#dvamxscan").html("")
                })
            })
        }
        var e, c, s, i, l = [], r = !1, d = !1, u = (new Date).getUTCMilliseconds(), m = "", h = null;
        return this.initialize = function() {
            switch (e = n,
            _finalEnvo = "",
            t) {
            case 0:
                _finalEnvo = ".dev";
                break;
            case 1:
                _finalEnvo = ".staging"
            }
            return c = "https://ws" + _finalEnvo + ".aramex.net/printscanmanager/",
            S.get(c + "templates/scan/modal.html?v=" + u, function(n) {
                m = n
            }),
            this
        },

        this.start = function() {
            var t = this;
            return JSPM.JSPrintManager.license_url = c + "jspm",
            JSPM.JSPrintManager.auto_reconnect = !0,
            JSPM.JSPrintManager.start(),
            JSPM.JSPrintManager.WS.onStatusChanged = function() {
                if (JSPM.JSPrintManager.websocket_status === JSPM.WSStatus.Open)
                    JSPM.JSPrintManager.getScanners().then(function(n) {
                        i = n;
                        n = new XMLHttpRequest;
                        n.onreadystatechange = function() {
                            return 4 === this.readyState && 200 === this.status ? (s = JSON.parse(this.responseText),
                            r = !0,
                            null === localStorage.getItem("scan_" + s.name) ? (l = [],
                            S.each(s.docs, function(n, t) {
                                l.push({
                                    id: t.id,
                                    name: t.name,
                                    scannerName: ""
                                })
                            }),
                            d = !1) : (d = !0,
                            l = JSON.parse(localStorage.getItem("scan_" + s.name))),
                            t.result({
                                result: "success",
                                resultId: 1,
                                client: s,
                                scanners: i
                            })) : 300 <= this.status ? t.result({
                                result: "clientId not found",
                                resultId: -2
                            }) : void 0
                        }
                        ,
                        n.open("GET", c + "clients/scan/" + e + ".json", !0),
                        n.send()
                    });
                else if (1 <= JSPM.JSPrintManager.websocket_status)
                    return t.result({
                        result: "failed to connect to JSPrintManager app",
                        resultId: -1
                    })
            }
        }
        ,
        this.result = null,
        this.onAfterScan = null,
        this.config = function() {
            a()
        }
        ,
        this.scan = function(i) {
            var e, o = this;
            r ? (e = "",
            d ? (S.each(l, function(n, t) {
                t.id === i.documentId && (e = t.scannerName)
            }),
            S("#dvamxscan").html(m),
            S("#dvamxscan").show(),
            S(".scan-close").click(function() {
                S("#dvamxscan").hide(),
                S("#dvamxscan").html("")
            }),
            S.get(c + "templates/scan/scan.html?v=" + u, function(n) {
                n = S("<div/>").html(n).contents();
                S(".scan-modal-body").append(n.html()),
                S("#dvScanNav").hide();
                var s = new JSPM.ClientScanJob;
                s.scannerName = e,
                s.pixelMode = JSPM.PixelMode.Color,
                s.resolution = parseInt(200),
                s.imageFormat = JSPM.ScannerImageFormatOutput.JPG,
                s.onUpdate = (n,t)=>{
                    var e, a, c;
                    n instanceof Blob ? 0 != n.size && (e = URL.createObjectURL(new Blob([n],{
                        type: "image/jpg"
                    })),
                    a = {
                        width: Math.round(96 / s.resolution * 100) + "%",
                        height: "auto",
                        display: "block",
                        margin: "auto",
                        border: "2px dotted grey"
                    },
                    S("#imgScanOutput").css(a),
                    S("#imgScanOutput").attr("src", e),
                    S("#imgScan").hide(),
                    S("#dvScanNav").show(),
                    (c = new FileReader).readAsDataURL(n),
                    c.onloadend = function() {
                        h = c.result
                    }
                    ,
                    S("#btnRe_Scan").click(function() {
                        o.scan(i)
                    }),
                    S("#btnProceed_Scan").click(function() {
                        o.onAfterScan(h),
                        S("#dvamxscan").hide(),
                        S("#dvamxscan").html("")
                    })) : console.info(n)
                }
                ,
                s.sendToClient()
            })) : a()) : (S("#dvamxprint").html(m),
            S("#dvamxprint").show(),
            S(".print-close").click(function() {
                S("#dvamxprint").hide(),
                S("#dvamxprint").html("")
            }),
            S.get(c + "templates/scan/downloads.html?v=" + u, function(n) {
                n = S("<div/>").html(n).contents();
                S(".scan-modal-body").append(n.html())
            }))
        }
        ,
        this.initialize()
    }
}(jQuery);
var _clientSetup = []
  , inputNumChange = function(n) {
    var t = $("#inCopies_" + n).val();
    /^([2-9]|1[0])$/.test(t) || $("#inCopies_" + n).val(1)
}
  , onScannerChange = function(e, a) {
    $.each(_clientSetup, function(n, t) {
        t.id === e && (t.scannerName = a.value)
    })
};
